import { Injectable } from '@angular/core';

@Injectable()
export class PersononboardConstantsService {
  constructor() { }
  public static PersonOnBoardCardModuleConst = {
    OnSelectedOfStaff: 'Staff',
    OnSelectedOfContractor: 'Contractor',
    OnSelectedOfVisitor: 'Visitor',
    OnSelectedOfThirdParty: 'Third party'
  }
  public static Status = {
    PendingForApproval: 'Pending For Approval',
    Rejected: 'Rejected',
    Delayed: 'Delayed',
    Expired: 'Expired',
    Granted: 'Granted',
    Blocked: 'Blocked'
  }
  public static Company = {
    B44: 'B44',
    QAMP: 'QAMP'
  }
  public static Location = {
    Pune: 'Pune',
    Mumbai: 'Mumbai'
  }
  public static PersonOnBoardUrl = {
    Routes: [
      {
        routeName: 'Home',
        routeURL: '../../home',
        isClickable: true
      },
      {
        routeName: 'New Pass',
        routeURL: '/pob/raise-passrequest/new',
        isClickable: true
      },

      {
        routeName: 'Pass Overview',
        routeURL: '/pob/pass-request-overview',
        isClickable: true
      },
      {
        routeName: 'POB List Overview',
        routeURL: '/pob/pob-list-overview',
        isClickable: true
      },
      {
        routeName: 'Check In/Out',
        routeURL: '/pob/check-in-out',
        isClickable: true
      }
    ],
    InnerRoutes: [
      {
        routeName: 'Home',
        routeURL: '../../home',
        isClickable: true
      },
      {
        routeName: 'New Pass',
        routeURL: '/pob/raise-passrequest/new',
        isClickable: true
      },

      {
        routeName: 'Pass Overview',
        routeURL: '/pob/pass-request-overview',
        isClickable: true
      },
      {
        routeName: 'POB List Overview',
        routeURL: '/pob/pob-list-overview',
        isClickable: true
      },
      {
        routeName: 'Check In/Out',
        routeURL: '/pob/check-in-out',
        isClickable: true
      }
    ],
    OfflineRoutes: [
      {
        routeName: 'POB List Overview',
        routeURL: '/pob/pob-list-overview',
        isClickable: true
      },
      {
        routeName: 'Check In/Out',
        routeURL: '/pob/check-in-out',
        isClickable: true
      }
    ],
    ReportRoutes: [

    ]
  };

  public static APIURL = {
    GetHSECheckDocuments: 'api/pob/get/getHSECheckDocuments',
    SaveorUpdatePassRequest: 'api/pob/SaveorUpdate/pobRequest',
    GetPrerequisiteConfiguration: 'api/pob/get/getPrerequisiteConfiguration',
    SearchAccesspassOverview: 'api/pob/search/searchAccesspassOverview',
    GetPOBResponseDetails: 'api/pob/get/getPOBResponseDetails',
    GetPassRequestStatus: 'api/pob/get/getPassRequestStatus',
    GetPassRequestStatusDoneFilter: 'api/pob/get/getPassRequestStatusDoneFilter',
    GetPassRequestId: 'api/pob/get/getDetailsByPassRequestId',
    GetPassRequestDetailsByEmailId: 'api/pob/get/getPassRequestDetailsByEmailId',
    GetDownListOfUser: 'api/pob/get/getDownListOfUser',
    UpdatePassRequest: 'api/pob/update/updatePassRequest',
    ContractHolderStatus: 'api/pob/update/contractHolderStatus',
    InsertCheckInCheckOutDetails: 'api/pob/insert/insertCheckInCheckOutDetails',
    GetPOBListOverviewDetails: 'api/pob/get/getPOBListDetails',
    GetDailyPOBListOverviewDetails: 'api/pob/get/getPOBListDetailsDatewise',
    GetPassRequestReportDetails: 'api/pob/get/getPassRequestReportDetails',
    GetExportToExcelPassRequests: 'api/pob/get/getExportToExcelPassRequests',
    GetExportToExcelPOBRequests: 'api/pob/get/getExportToExcelPOBRequests',
    DownloadPDF: 'api/pob/get/downloadpdf',
    DownloadZIP: 'api/pob/get/downloadzip',
    GetApprovals: 'api/pob/get/approvals',
    SetApprovals: 'api/pob/get/setapprovals',
    GetPassRequestDetailsByPassId: 'api/pob/GetPassRequestDetailsByPassId',
    RenewPass: 'api/pob/RenewPass',
    RecreatePrintPass: 'api/pob/RecreatePrintPass'
  }

  public static POBStatus = {
    Status: [
      {
        StatusId: 0,
        StatusName: 'all'
      },
      {
        StatusId: 1,
        StatusName: 'Open'
      },
      {
        StatusId: 2,
        StatusName: 'Closed'
      },
      {
        StatusId: 3,
        StatusName: 'Rejected'
      },
      {
        StatusId: 4,
        StatusName: 'Delayed'
      },
      {
        StatusId: 5,
        StatusName: 'Waived'
      }
    ]
  }
  public static ColumnConstants = {
    ASC: 'ASC',
    DESC: 'DESC',
    POBId: 'POBId',
    POBDate: 'POBDate',
    PassId: 'PassId',
    ExpiryDate: 'Expiry Date',
    CreatedDate: 'Created Date'
  }

  public static Documents = {
    1: 'OPAL Defensive Driving Permit',
    2: 'Rigging and Banksman Course Card',
    3: 'PTW H/A Card',
    5: 'HSE Certificates'
  }
}
